import React, { FunctionComponent } from 'react';

interface AppLayoutProps {}

const AppLayout: FunctionComponent<AppLayoutProps> = ({ children }) => {


    return (
        <div className="app__background">
            <div className="app__container ">
                <main className="container container--app">{children}</main>
            </div>
        </div>
    )
}

export default AppLayout;